import { IWishlistItem } from '@/types';

export class WishlistItem implements IWishlistItem {
	constructor(
		public readonly id: number,
		public readonly name?: string,
	) {}
}
